import React from 'react';
import { TABS } from '@/components/tabs/tabConfig';

const SOCIAL = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/CrossroadsChurchPhilippines',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/crossroadschurchph',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.75" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@c4crossroads',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M22.54 6.42A2.78 2.78 0 0 0 20.6 4.46C18.88 4 12 4 12 4s-6.88 0-8.6.46A2.78 2.78 0 0 0 1.46 6.42 29.94 29.94 0 0 0 1 12a29.94 29.94 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.4 19.54C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-1.96A29.94 29.94 0 0 0 23 12a29.94 29.94 0 0 0-.46-5.58z" />
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white" />
      </svg>
    ),
  },
];

const QUICK_LINKS = [
  { label: 'Service Times', href: '#community' },
  { label: 'Upcoming Events', href: '#community' },
  { label: 'Gravity Youth', href: '#gravity' },
  { label: 'Volunteer', href: '#volunteer' },
  { label: 'Connect', href: '#connect' },
];

const CONTACT = [
  { label: '2/F Crossroads Church, Robinsons Galleria Cebu', href: null },
  { label: 'Gen. Maxilom Avenue, Cebu City', href: null },
  { label: 'hello@crossroadschurch.ph', href: 'mailto:info@crossroadschurch.ph' },
];

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: 'var(--color-surface)',
        borderTop: '1px solid var(--color-border)',
      }}
    >
      <div className="px-6 md:px-10 lg:px-16 pt-14 pb-10">
        {/* Top grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">

          {/* Brand */}
          <div>
            <img
              src="https://crossroadsdatarepocdn-prod.sgp1.cdn.digitaloceanspaces.com/logo-black.png"
              alt="Crossroads Church"
              className="h-8 w-auto mb-5"
              style={{ filter: 'invert(1)' }}
            />
            <p
              className="font-haffer font-light leading-relaxed mb-6"
              style={{ fontSize: '0.8rem', color: 'rgba(245,244,240,0.35)', maxWidth: '22ch' }}
            >
              Your home. Your family.
            </p>
            {/* Socials */}
            <div className="flex items-center gap-4">
              {SOCIAL.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="transition-opacity duration-200"
                  style={{ color: 'rgba(245,244,240,0.4)', opacity: 1 }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-white)')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(245,244,240,0.4)')}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Sitemap */}
          <div>
            <p
              className="eyebrow mb-5"
              style={{ color: 'rgba(245,244,240,0.35)' }}
            >
              Navigation
            </p>
            <ul className="flex flex-col gap-3">
              {TABS.map((tab) => (
                <li key={tab.id}>
                  <a
                    href={tab.hash}
                    className="font-haffer font-light uppercase tracking-widest transition-colors duration-200"
                    style={{ fontSize: '0.7rem', letterSpacing: '0.18em', color: 'rgba(245,244,240,0.45)' }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-white)')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(245,244,240,0.45)')}
                  >
                    {tab.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p
              className="eyebrow mb-5"
              style={{ color: 'rgba(245,244,240,0.35)' }}
            >
              Find Us
            </p>
            <ul className="flex flex-col gap-3">
              {CONTACT.map((c) =>
                c.href ? (
                  <li key={c.label}>
                    <a
                      href={c.href}
                      className="font-haffer font-light transition-colors duration-200"
                      style={{ fontSize: '0.8rem', color: 'rgba(245,244,240,0.45)' }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-white)')}
                      onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(245,244,240,0.45)')}
                    >
                      {c.label}
                    </a>
                  </li>
                ) : (
                  <li key={c.label}>
                    <p
                      className="font-haffer font-light"
                      style={{ fontSize: '0.8rem', color: 'rgba(245,244,240,0.35)' }}
                    >
                      {c.label}
                    </p>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 pt-8"
          style={{ borderTop: '1px solid var(--color-border)' }}
        >
          <p
            className="font-haffer font-light"
            style={{ fontSize: '0.7rem', color: 'rgba(245,244,240,0.2)', letterSpacing: '0.05em' }}
          >
            © {year} Crossroads Church. All rights reserved.
          </p>
          <p
            className="font-haffer font-light"
            style={{ fontSize: '0.7rem', color: 'rgba(245,244,240,0.15)', letterSpacing: '0.05em' }}
          >
            Cebu City, Philippines
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
